export const BankHubUrl =  {
    login: '/bankhub/auth/login',
    authorize: '/bankhub/auth/authorize-code',
    checkPartner: '/bankhub/auth/check-partner',
    captcha: '/bankhub/auth/gen-captcha',
    batchTranInfo: "/bankhub/transaction/batch-transaction-info",
    tranInfo: "/bankhub/transaction/info",
    callBackUrl: "/bankhub/transaction/callback-url",
    transactionAccount: '/bankhub/transaction/account',
    authenType: '/bankhub/user/authen-type',
    userInfo: '/bankhub/user/info',
    verifyDigital: '/bankhub/transaction/verify/digital-signature',
    genOTP: '/bankhub/transaction/gen-otp',
    verifyOTP: '/bankhub/transaction/verify/otp',
    batchListTranInfo: '/bankhub/transaction/list-transaction-info'
}